// Configuração de API - sempre aponta para o backend de produção
export const API_URL = 'https://memed-doctor-reg.emergent.host';

// Backend local para endpoints proxy (endereço do paciente, etc.)
export const LOCAL_API_URL = window.location.origin;
